import { getProductData } from '../utils/data';

export default class PriceBlock {
    constructor() {
        this.validationBlock = document.querySelector(
            '.product-description__quantity-counter .product-description__quantity-counter-validation-error'
        );
        this.validationMessage = document.querySelector(
            '.product-description__quantity-counter .product-description__quantity-counter-validation-error-message'
        );
        this.addToCartButton = document.getElementById('add-to-cart');
        this.decBlock = document.querySelector(
            '.product-description__quantity-counter #btn-counter-dec'
        );
        this.incBlock = document.querySelector(
            '.product-description__quantity-counter #btn-counter-inc'
        );
        this.textField = PriceBlock.getPriceField();
        this.val = parseInt(this.textField.value, 10);

        this.decBlock.disabled = this.val < 2;
        this.decBlock.addEventListener('click', this.updateValueBy(-1));
        this.incBlock.addEventListener('click', this.updateValueBy(1));
        this.textField.addEventListener('blur', this.handleChange);
        this.loadCYS();
        document.getElementById('pdp_form').addEventListener('submit', event => {
            event.preventDefault();
            if (this.textField.value === '') {
                this.textField.value = 1;
            }
            this.validate(this.textField.value);
        });
    }

    static init(...args) {
        if (PriceBlock.getPriceField()) {
            return new PriceBlock(...args);
        }
        return null;
    }

    static getPriceField = () =>
        document.querySelector(
            '.product-description__quantity-counter .product-description__quantity-counter-input'
        );

    updateValueBy = step => () => {
        // eslint-disable-next-line
        if (isNaN(this.val)) {
            this.val = 0;
        }
        // eslint-disable-next-line
        this.val = this.val + step;
        this.textField.value = this.val;
        this.validate(this.val);
    };

    setValue(value) {
        this.textField.value = value;
        this.textField.defaultValue = value;
    }

    handleChange = ({ target: { value } }) => {
        if (value === '') {
            this.val = 1;
            // eslint-disable-next-line
        } else if (isNaN(value)) {
            this.val = value;
        } else {
            this.val = parseInt(value, 10);
        }

        this.setValue(this.val);
        this.validate(this.val);
    };

    validate = value => {
        this.decBlock.disabled = value < 2;

        if (value <= 0) {
            this.validationMessage.innerText = getProductData().msgZeroQuantity;
            // eslint-disable-next-line
        } else if (isNaN(value)) {
            this.validationMessage.innerText = getProductData().msgEmptyQuantity;
        } else {
            this.validationBlock.classList.add('hidden');
            this.addToCartButton.disabled = false;
            this.textField.classList.remove('product-description__quantity-counter-input_invalid');
            return true;
        }
        this.validationBlock.classList.remove('hidden');
        this.addToCartButton.disabled = true;
        this.textField.classList.add('product-description__quantity-counter-input_invalid');
        return false;
    };

    async loadCYS() {
        const { CYS } = await import(/* webpackChunkName: "pdp_cys" */ '../cys/cys');
        const addToCart = CYS(getProductData().siteId);

        this.addToCartButton.classList.remove('btn_loading');

        this.addToCartButton.addEventListener('click', event => {
            event.preventDefault();
            addToCart({
                productId: getProductData().productId,
                skuId: getProductData().skuId,
                quantity: this.val,
            });
        });
    }
}
